<style lang="stylus">
    .mmblock
        .grid-file
            position relative
            width 198px
            height 172px
            margin-right 24px
            margin-bottom 24px
            text-align center
            font-size 12px
            cursor pointer
            user-select none
            border-radius 8px
            background #F2F4F9
            padding 8px 8px 0
            border 1px solid transparent
            &.active,&:hover
                border 1px solid #017fff
            >img
                display block
                width 178px
                height 124px
                border-radius 6px
                padding 0
                pointer-events none
            .grid-titlebox
                position relative
                display flex
                align-items center
                height 40px
                background none
                padding 0
                .titlebox-text
                    line-height 1
                    color #222
                    font-size 12px
                    textOverflow()
        .list-file
            width 100%
            height 56px
        &.dialog-view
            padding-right 0
            .grid-file
                margin-right 16px
                margin-bottom 16px
    .dark-theme__mmblock
        .grid-file
            background rgba(255, 255, 255, 0.08)
            .grid-titlebox
                .titlebox-text
                    color #fff
</style>

<template>
    <div
        class="mmblock"
        :class="{
            'dark-theme__mmblock': isPCDarkMode == 2,
            'dialog-view': isDialog,
        }"
        @click.stop="selectMMFile()"
        @dblclick.prevent.stop="dblClickFile"
        @contextmenu.prevent.stop
    >
        <div v-if="mode == 'grid'" class="grid-file" :class="{ active: mmSelect == file.key }" data-type="emmx">
            <img :src="require(`@/home/assets/img/files/mm-grid${isPCDarkMode == 2 ? '-dark' : ''}.svg`)" alt="" />
            <div class="grid-titlebox">
                <p class="titlebox-text">{{ name }}</p>
            </div>
        </div>
        <div
            v-else
            class="pcview-files-item-list"
            :class="{
                'list-item-active': mmSelect == file.key,
                'dark-theme_pcview-listfile': isPCDarkMode == 2,
            }"
            data-type="emmx"
        >
            <div class="file-name">
                <img class="file-icon" src="@/home/assets/img/files/mm-list.svg" alt="" />
                <span :title="name">{{ name }}</span>
            </div>
            <div class="file-time">
                {{ formatDate(file.lastModified) }}
            </div>
            <div class="file-customtag"></div>
            <div class="file-size">
                {{ renderSize(file.size) }}
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    @Component({
        components: {},
    })
    export default class MMBlock extends Vue {
        @Prop()
        file;
        @Prop()
        name;
        @Prop()
        mode;
        @Prop()
        mmSelect;

        timer = null;
        renderSize(size) {
            let s = size / 1024 / 1024;
            if (s > 1) {
                return s.toFixed(2) + "M";
            } else {
                return (size / 1024).toFixed(0) + "KB";
            }
        }
        formatDate(str) {
            const addZero = (num) => {
                return (num < 10 && `0${num}`) || num;
            };
            let date = new Date(str);
            let Y = date.getFullYear();
            let M = date.getMonth() + 1;
            let D = date.getDate();
            let H = date.getHours();
            let Min = date.getMinutes();
            let sec = date.getSeconds();
            return `${Y}/${addZero(M)}/${addZero(D)} ${addZero(H)}:${addZero(Min)}:${addZero(sec)}`;
        }
        selectMMFile() {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => {
                this.$emit("selectMMFile", this.file.key);
            }, 250);
        }
        dblClickFile() {
            clearTimeout(this.timer);
            let obj = {
                title: this.$t("remind"),
                content: this.$t("openText"),
                useDark: this.isPCDarkMode,
                isPC: this.isPC,
                width: 480,
                useIcon: true,
                id: this.file.key,
                noMask: true,
            };
            if (this.qtAvaild) {
                Object.assign(obj, {
                    confirmText: this.$t("confirm"),
                    cancelText: this.$t("cancel"),
                });
            }
            this.$edModal.show(obj);
        }
        deleteFile() {
            let obj = {
                title: this.$t("remind"),
                content: this.$t("deleteText"),
                useDark: this.isPCDarkMode,
                isPC: this.isPC,
                width: 480,
                useIcon: true,
                id: this.file.key,
                noMask: true,
            };
            if (this.qtAvaild) {
                Object.assign(obj, {
                    confirmText: this.$t("confirm"),
                    cancelText: this.$t("cancel"),
                });
            }
            this.$edModal.show(obj);
        }
        get qtAvaild() {
            let win: any = window;
            return win.$qt && win.$qt.jsCallOpenMasterSoft;
        }
        openConfirm(id) {
            if (id != this.file.key) return;
            let win: any = window;
            win.$qt.jsCallOpenMasterSoft();
        }
        keyEvent(e) {
            if (this.mmSelect == this.file.key && (e.keyCode == 46 || e.keyCode == 8)) {
                this.deleteFile();
            }
        }
        //生命周期
        isDialog = false;
        mounted() {
            let urlParmas = new URLSearchParams(location.search.substr(1));
            this.isDialog = !!urlParmas.get("dialog");
            this.$bus.$on("edmodal-confirm", this.openConfirm);
            window.addEventListener("keydown", this.keyEvent);
        }

        created() {}
        beforeDestroy() {
            this.$bus.$off("edmodal-confirm", this.openConfirm);
            window.removeEventListener("keydown", this.keyEvent);
        }
    }
</script>
<i18n>
{
    "zh": {
    "remind": "通知",
    "confirm": "确定",
    "cancel": "取消",
    "openText": "注意：亿图脑图MindMaster的文件需要使用亿图脑图MindMaster软件打开; 可以通过右键菜单设置该文件夹内是否显示亿图脑图文件",
    "deleteText": "注意：亿图脑图MindMaster的文件需要使用亿图脑图MindMaster软件删除"
    },
    "en": {
    "remind": "Reminder",
    "confirm": "Confirm",
    "cancel": "Cancel",
    "openText": "Note: EdrawMind files can only be opened from within the EdrawMind app.You can show/hide EdrawMind files through the right-click menu.",
    "deleteText": "Note: EdrawMind files can only be deleted from within the EdrawMind app."
    },
    "fr": {
    "remind": "rappeler",
    "confirm": "Confirmer",
    "cancel": "Annuler"
    },
    "de": {
    "remind": "Hinweis ",
    "confirm": "Sichern",
    "cancel": "Abbrechen"
    },
    "jp": {
    "remind": "通知",
    "confirm": "確認",
    "cancel": "キャンセル"
    },
    "es": {
    "remind": "Recordatorio",
    "confirm": "Aceptar",
    "cancel": "Cancelar"
    },
    "pt": {
    "remind": "Alerta",
    "confirm": "OK",
    "cancel": "Cancelar"
    },
    "it": {
    "remind": "Promemoria",
    "confirm": "OK",
    "cancel": "Annulla"
    },
    "tw": {
    "remind": "温馨提示",
    "confirm": "確認",
    "cancel": "取消"
    },
    "kr": {
    "remind": "알림",
    "confirm": "확인 ",
    "cancel": "취소"
    }
}
</i18n>
